import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormCurrencyPercent, type FormCurrencyPercentProps } from "../fields/FormCurrencyPercent";
import type { FormComponentProps } from "../types";

export type FormCurrencyPercentComponentProps<TFieldValues extends FieldValues> = Omit<
	FormComponentProps<TFieldValues>,
	"name" | "label"
> &
	FormCurrencyPercentProps<TFieldValues>;

export const FormCurrencyPercentComponent = <TFieldValues extends FieldValues>(
	props: FormCurrencyPercentComponentProps<TFieldValues>,
) => {
	const { formMethods, currencyName } = props;
	const amountType = formMethods.watch(props.amountTypeName);
	return (
		<FormComponent
			{...props}
			name={currencyName}
			label={amountType === "dollars" ? "Bond Amount in Dollars" : "Bond Amount as Percent of Bid"}
		>
			<FormCurrencyPercent {...props} />
		</FormComponent>
	);
};
